import highlights from '@/mixins/search/highlights'

export default {
  mixins: [highlights],
  props: {
    highlights: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    highlightsLoading: {
      type: Boolean,
      required: true
    },
    link: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      descriptionPrefix: '<span class="t-500">About: </span>'
    }
  },
  computed: {
    industryAndTypeString () {
      let output = ''
      if (this.data.industries) {
        const relevantIndustries = this.data.industries.filter(i => {
          return i !== 'Finance' && i !== 'Financial Services'
        })
        if (!this.isEmpty(relevantIndustries)) {
          output = `${relevantIndustries.join(', ')} - `
        }
      }

      output = `${output}${this.data.organisation_types.join(' and ')}`
      return output
    },
    title () {
      return this.highlights && this.highlights.name ? this.highlights.name[0] : this.data.name
    },
    description () {
      if (this.highlights && this.highlights.about) {
        return `${this.descriptionPrefix} ${this.stripTagsNoMark(this.highlights.about)}`
      } else if (this.data.about) {
        return `${this.descriptionPrefix} ${this.stripTagsNoMark(this.data.about)}`
      }
      return ''
    },
    foundationYear () {
      if (!this.data.foundation_date) return ''
      return new Date(this.data.foundation_date).getFullYear()
    },
    fundingData () {
      if (!this.data.funding || !this.data.funding.stage) return ''
      return `${this.data.funding.stage} ${this.data.funding.year ? `(${this.data.funding.year})` : ''}`
    }
  }
}
